exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".StatusAlert-default-taq6v{overflow:hidden}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl.StatusAlert-enterActive-VLN9s .StatusAlert-content-2OL6N{top:0;transition:top .5s ease}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl.StatusAlert-enterActive-VLN9s .StatusAlert-spacer-oIA6K{height:53px;transition:height .5s ease}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl .StatusAlert-content-2OL6N{top:-53px}.StatusAlert-default-taq6v.StatusAlert-enter-1ufTl .StatusAlert-spacer-oIA6K{height:0}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m.StatusAlert-leaveActive-1RpDc .StatusAlert-content-2OL6N{top:-53px;transition:top .5s ease}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m.StatusAlert-leaveActive-1RpDc .StatusAlert-spacer-oIA6K{height:0;transition:height .5s ease}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m .StatusAlert-content-2OL6N{top:0}.StatusAlert-default-taq6v.StatusAlert-leave-6YS1m .StatusAlert-spacer-oIA6K{height:53px}.StatusAlert-default-taq6v .alert{border-top:0;border-radius:0 0 10px 10px}.StatusAlert-content-2OL6N{position:fixed;top:0;right:0;left:0;height:53px;z-index:10000;opacity:.95}.StatusAlert-spacer-oIA6K{height:53px}", ""]);

// exports
exports.locals = {
	"default": "StatusAlert-default-taq6v",
	"enter": "StatusAlert-enter-1ufTl",
	"enterActive": "StatusAlert-enterActive-VLN9s",
	"content": "StatusAlert-content-2OL6N",
	"spacer": "StatusAlert-spacer-oIA6K",
	"leave": "StatusAlert-leave-6YS1m",
	"leaveActive": "StatusAlert-leaveActive-1RpDc"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/app/components/StatusAlert.less
// module id = 1600
// module chunks = 0